var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChangeTextDimensionNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.244,
    height: 18.121,
    viewBox: "0 0 30.244 18.121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-change-text-dimension-normal",
    transform: "translate(-169.786 -125.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M169.786,142.7l2.693-.4h.534l2.934.4v1.1h-6.161Zm7.991-17.025h1.679l6.176,18.121h-2.62l-5.357-16.009.64-.077-5.464,16.086h-1.283Zm-3.131,11.021H181.9l.44,1.256h-8.131ZM179.9,142.7l3.367-.4h.61l3.34.4v1.093H179.9Z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M189.828,143.055l1.591-.236h.3l1.6.236v.736h-3.491Zm4.564-9.717h1.286l3.567,10.453h-2.081l-2.91-8.9.476-.4-3.1,9.3H190.8Zm-1.76,6.424h4.234l.3.82h-4.793Zm2.859,3.31,1.872-.236h.688l1.979.236v.719h-4.539Z",
    fill: "#333"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangeTextDimensionNormal);
export default __webpack_public_path__ + "static/media/icon-change-text-dimension-normal.d2d5bb29e24991cec3ef8a88e2de16ae.svg";
export { ForwardRef as ReactComponent };